import e from "../managers/braze-instance.js";
import yt from "./utils/push-utils.js";
export function isPushBlocked() {
  if (e.X()) return yt.isPushBlocked();
}
